export const formatDiffingValue = (value: unknown): string => {
	if (value === null || value === undefined || value === '') return '-';
	if (typeof value === 'boolean') return value ? 'Yes' : 'No';

	if (Array.isArray(value)) {
		if (value.length === 0) return 'Empty';
		const first = value[0];
		if (first && typeof first === 'object' && 'name' in first) {
			// eslint-disable-next-line @typescript-eslint/no-explicit-any
			return value.map((v: any) => v.name).join(', ');
		}
		return `${value.length} items`;
	}

	if (typeof value === 'object') return JSON.stringify(value);
	return String(value);
};
